"use client"

import { useEffect } from "react"
import { useTrack } from "@owlcat/app-shell"
import { useRecentlyViewed } from "@/hooks/use-recently-viewed"

/**
 * Invisible client component that tracks product page views
 * in the recently-viewed localStorage list + emits the fleet
 * `product_viewed` analytics event (ids only, no PII).
 */
export default function RecentlyViewedTracker({
  handle,
  productId,
  category,
}: {
  handle: string
  productId?: string
  category?: string
}) {
  const { addToRecentlyViewed } = useRecentlyViewed()
  const track = useTrack()

  useEffect(() => {
    if (handle) {
      addToRecentlyViewed(handle)
    }
  }, [handle, addToRecentlyViewed])

  useEffect(() => {
    if (!productId) return
    track("product_viewed", category ? { product_id: productId, category } : { product_id: productId })
  }, [productId, category, track])

  return null
}
